import apiClient from "../../axios/apiClient";


export const getTypeOfClaimList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_TYPE_OF_CLAIMLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/ClaimType`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_TYPE_OF_CLAIMLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TYPE_OF_CLAIMLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveTypeOfClaimData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_TYPE_OF_CLAIM_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-ClaimType`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_TYPE_OF_CLAIM_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_TYPE_OF_CLAIM_REJECTED", payload: error.response });
    }
  };
  

  export const getTypeOfClaimListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_TYPE_OF_CLAIMLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/ClaimType/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_TYPE_OF_CLAIMLISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TYPE_OF_CLAIMLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateTypeOfClaimData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-ClaimType/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_REJECTED", payload: error.response });
  }
};


export const updateTypeOfClaimStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-ClaimType-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_TYPE_OF_CLAIM_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteTypeOfClaimData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_TYPE_OF_CLAIM_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-ClaimType/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_TYPE_OF_CLAIM_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_TYPE_OF_CLAIM_REJECTED", payload: error.response });
  }
};